// Card Component
import { forwardRef, ReactNode } from 'react';
import { Card as MuiCard, CardContent, CardHeader, CardProps as MuiCardProps } from '@mui/material';

interface CardProps extends MuiCardProps {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  noPadding?: boolean;
  children?: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { children, title, subtitle, action, noPadding, ...props },
  ref,
) {
  return (
    <MuiCard ref={ref} {...props}>
      {(title || subtitle || action) && (
        <CardHeader
          title={title}
          subheader={subtitle}
          action={action}
          titleTypographyProps={{ variant: 'h6' }}
          subheaderTypographyProps={{ variant: 'body2' }}
        />
      )}
      {noPadding ? children : <CardContent>{children}</CardContent>}
    </MuiCard>
  );
});

Card.displayName = 'Card';

export default Card;
